namespace TabAurous.ProductDevelopment {
    export namespace SpecSheetBOMService {
        export const baseUrl = 'ProductDevelopment/SpecSheetBOM';

        export declare function Create(request: Serenity.SaveRequest<SpecSheetBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SpecSheetBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SpecSheetBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SpecSheetBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/SpecSheetBOM/Create",
            Update = "ProductDevelopment/SpecSheetBOM/Update",
            Delete = "ProductDevelopment/SpecSheetBOM/Delete",
            Retrieve = "ProductDevelopment/SpecSheetBOM/Retrieve",
            List = "ProductDevelopment/SpecSheetBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SpecSheetBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
